// extracted by mini-css-extract-plugin
module.exports = {"SNewsWrapper":"FilmwebNews_SNewsWrapper__eqcXW","SImageTitleAspect2_1":"FilmwebNews_SImageTitleAspect2_1__8LAlu"};